<template>
  <section class="aidrama-box8">
    <!-- Pixso 65:4121 part8 — 393×865@1×；rem = @1× px × 2 -->
    <img
      class="aidrama-box8__bg"
      :src="part8Bg"
      alt=""
      aria-hidden="true"
    />
    <div class="aidrama-box8__inner">
      <header class="aidrama-box8__head">
        <h2 class="aidrama-box8__title">
          <span class="aidrama-box8__title-line aidrama-box8__title-line--accent"
            >多维服务坚实护航</span
          >
          <span class="aidrama-box8__title-line">一站式保障AI漫剧创作学习</span>
        </h2>
        <p class="aidrama-box8__sub">保姆级护航 — 配套服务与保障</p>
      </header>

      <div class="aidrama-box8__grid">
        <div
          v-for="(row, rowIndex) in featureRows"
          :key="rowIndex"
          class="aidrama-box8__row"
        >
          <article
            v-for="item in row"
            :key="item.title"
            class="aidrama-box8-card"
            :class="`aidrama-box8-card--${item.tone}`"
          >
            <h3 class="aidrama-box8-card__title">{{ item.title }}</h3>
            <p class="aidrama-box8-card__desc">{{ item.desc }}</p>
          </article>
        </div>
      </div>

      <div class="aidrama-box8__promo">
        <h3 class="aidrama-box8__promo-title">
          <span class="aidrama-box8__promo-title-line">现在报名</span>
          <span class="aidrama-box8__promo-title-line">抓住AI漫剧红利期</span>
        </h3>
        <p class="aidrama-box8__promo-desc">
          行业红利窗口期有限，越早学习越占优势，当下报名抢占学习名额，把握住难得的创业增收好机会
        </p>
      </div>

      <button type="button" class="aidrama-box8__cta" @click="handleCtaClick">
        <span class="aidrama-box8__cta-text">立即报名 抢占学习名额</span>
        <img class="aidrama-box8__cta-arrow" :src="btnArrow" alt="" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "AidramaBox8",
  data() {
    return {
      part8Bg: require("../../../assets/coursePage/aidrama/box8/part8_bg.png"),
      btnArrow: require("../../../assets/coursePage/aidrama/box8/btn_arrow.png"),
      features: [
        {
          title: "零基础友好入门",
          desc: "零门槛就学，从电脑配置、软件安装起步，无剪辑、无AI相关经验也能轻松上手",
          tone: "blue",
        },
        {
          title: "专属小白培养模式",
          desc: "摒弃精英筛选，专注新手孵化，定制专属入门成长特训计划",
          tone: "purple",
        },
        {
          title: "多元授课陪伴体系",
          desc: "两个月系统特训，直播授课搭配支持回放，可反复观看班主任、助教5v1在岗，全天实时答疑解惑",
          tone: "blue",
        },
        {
          title: "实战落地权益保障",
          desc: "实战锻炼技能，提供技术扶持与资源对接学完即落地，支持免费重学",
          tone: "purple",
        },
      ],
    };
  },
  computed: {
    featureRows() {
      return [this.features.slice(0, 2), this.features.slice(2, 4)];
    },
  },
  methods: {
    handleCtaClick() {
      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第8屏-立即报名 抢占学习名额", {
          终端: "H5",
          名称: "传智AI漫剧页-第8屏-立即报名 抢占学习名额",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.aidrama-box8 {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.aidrama-box8__bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  pointer-events: none;
}

.aidrama-box8__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 80px 40px 100px;
  box-sizing: border-box;
}

/* 65:4122 gap 6px */
.aidrama-box8__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.aidrama-box8__title {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  width: 100%;
}

.aidrama-box8__title-line {
  font-size: 48px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(47, 52, 59, 1);
  white-space: nowrap;
}

.aidrama-box8__title-line--accent {
  color: rgba(79, 86, 255, 1);
}

.aidrama-box8__sub {
  margin: 0;
  width: 100%;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(64, 69, 77, 1);
}

/* 65:4129 等 — 170×161/164；列 gap 10、行 gap 11 */
.aidrama-box8__grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  width: 100%;
  margin: 30px 0 0;
  padding: 0 6px;
  box-sizing: border-box;
}

.aidrama-box8__row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  width: 100%;
}

.aidrama-box8-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1 1 0;
  min-width: 0;
  padding: 40px;
  box-sizing: border-box;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(225.00deg, rgba(223, 235, 255, 1) 0%,rgba(246, 252, 255, 1) 49.563%,rgba(209, 232, 255, 1) 100%);
}

.aidrama-box8-card__title {
  margin: 0;
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 50px;
  letter-spacing: 4px;
  text-align: center;
  white-space: nowrap;
}

.aidrama-box8-card--blue .aidrama-box8-card__title {
  color: rgba(79, 86, 255, 1);
}

.aidrama-box8-card--purple .aidrama-box8-card__title {
  color: rgba(147, 73, 216, 1);
}

.aidrama-box8-card__desc {
  margin: 0;
  width: 252px;
  max-width: 100%;
  font-size: 24px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 2px;
  color: rgba(47, 52, 59, 1);
}

/* 65:4141 / 65:4142 */
.aidrama-box8__promo {
  align-self: flex-start;
  width: 320px;
  max-width: 100%;
  margin-top: 104px;
  padding: 0 14px;
  box-sizing: border-box;
}

.aidrama-box8__promo-title {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.aidrama-box8__promo-title-line {
  font-size: 40px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  color: rgba(255, 87, 23, 1);
  white-space: nowrap;
}

.aidrama-box8__promo-desc {
  margin: 20px 0 0;
  font-size: 24px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 4px;
  color: rgba(51, 51, 51, 1);
}

/* 65:4126 */
.aidrama-box8__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 108px;
  padding: 40px 40px 40px 52px;
  box-sizing: border-box;
  border: none;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(
    270deg,
    rgba(188, 117, 255, 1) 0%,
    rgba(117, 104, 255, 1) 100%
  );
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box8__cta-text {
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box8__cta-arrow {
  display: block;
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.4;
}
</style>
